import styles from "./Indicator.module.scss";
import { HTMLProps } from "react";
import classNames from "classnames";

export interface IndicatorProps extends HTMLProps<HTMLDivElement> {
  /** The number to display within the indicator*/
  count: number;
  /** The maximum number to display, numbers larger than this will show 'maximum number+' */
  maximumNumber?: number;
}

export const Indicator = (props: IndicatorProps) => {
  const { count, maximumNumber = 99, className, ...rest } = props;

  const overflowLabel = count > maximumNumber ? `${maximumNumber}+` : count;
  const classes = classNames(styles.indicator, className);

  return (
    <div
      className={classes}
      data-testid={"indicator-pill"}
      role="status"
      {...rest}
    >
      {overflowLabel}
    </div>
  );
};
